"use client";

import { memo, useEffect, useState } from "react";
import axiosInstance from "@/lib/axios";
import CustomImage from "@/components/ui/CustomImage";

let cachedLogoUrl;

const Logo = ({ big, inverted, showMark = true }) => {
	const colorClass = inverted ? "text-white" : "text-inherit";
	const [logoUrl, setLogoUrl] = useState(cachedLogoUrl ?? null);

	useEffect(() => {
		if (cachedLogoUrl !== undefined) {
			setLogoUrl(cachedLogoUrl || null);
			return;
		}

		let active = true;

		axiosInstance
			.get("/settings")
			.then(({ data }) => {
				if (!active) return;
				const url = data?.data?.appLogoUrl || data?.data?.appLogo || "";
				cachedLogoUrl = url;
				setLogoUrl(url || null);
			})
			.catch(() => {
				if (!active) return;
				cachedLogoUrl = "";
				setLogoUrl(null);
			});

		return () => {
			active = false;
		};
	}, []);

	return (
		<span className={`logo-brand${big ? " logo-brand--big" : ""}${inverted ? " logo-brand--inverted" : ""}`}>
			{showMark && (
				<span className="logo-brand__mark">
					{logoUrl ? (
						<CustomImage
							src={logoUrl}
							alt="जावार्ता"
							width={big ? 27 : 23}
							height={big ? 27 : 23}
							className="logo-brand__image"
							folder="settings"
						/>
					) : (
						<span className="logo-brand__fallback" aria-hidden="true">
							प
						</span>
					)}
				</span>
			)}
			<span className={`logo-brand__text ${colorClass}`}>
				जावार्ता
			</span>
		</span>
	);
};

export default memo(Logo);
